import { useCallback, useEffect, useState } from 'react';
import { getMedidas } from '../api/antropometriaApi';
import { formatDateDDMMYYYYHHmm } from '../utils/antropometriaFormatters';

const toTableRow = (medida) => ({
  id: medida.codigo,
  codigo: medida.codigo,
  pacienteId: medida.paciente ? medida.paciente.id : null,
  paciente: medida.paciente ? `${medida.paciente.firstname} ${medida.paciente.lastname}` : null,
  fechaRaw: medida.createdAt,
  createdAt: formatDateDDMMYYYYHHmm(medida.createdAt),
  talla: medida.talla,
  peso: medida.peso,
  perimetroAbdominal1: medida.perimetroAbdominal1,
  perimetroAbdominal2: medida.perimetroAbdominal2,
  perimetroAbdominal3: medida.perimetroAbdominal3,
  mediaPerimetroAbdominal: medida.mediaPerimetroAbdominal,
  grasa: medida.grasa,
  nivelGrasa: medida.nivelGrasa,
  musculo: medida.musculo,
  imc: medida.imc,
  bd: medida.bd,
  bi: medida.bi,
  pd: medida.pd,
  pi: medida.pi,
  pesoBrazosPiernas: medida.pesoBrazosPiernas,
  smi: medida.smi,
  profesional: medida.user ? `${medida.user.firstname} ${medida.user.lastname}` : null,
});

export const useAntropometriaTable = () => {
  const [medidas, setMedidas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMedidas = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getMedidas();
      setMedidas(data.map(toTableRow));
    } catch (error) {
      console.error('Error fetching medidas:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMedidas();
  }, [fetchMedidas]);

  return {
    medidas,
    loading,
    fetchMedidas,
  };
};
